import styled, { css } from 'styled-components';

import { Colors } from '@rockalingua/ui';

type ContainerProps = {
  $size?: 'large' | 'small';
};

export const Container = styled.div<ContainerProps>`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 32px;
  border-radius: 12px;

  ${({ $size }) => {
    if ($size === 'small') {
      return css`
        background-color: ${Colors.MAIN_VARIANTS[10]};
        padding: 16px;
      `;
    }
    return '';
  }}
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
